<div class="candidate-job-match-profile-container">
    <div class="main-box">
        <div class="row">
            <div class="col-xs-12" *ngIf="!isLoading">
                <tabset>
                    <tab *ngFor="let tab of validTabs" [active]="tab.isActive"
                        (selectTab)="selectTab(tab)">
                        <ng-template tabHeading>
                            <span>{{tab.name}}</span>
                            <span class="fa fa-exclamation-circle red ml-2" tooltip-placement="top" tooltip="Complete Missing Information"
                                *ngIf="(tab.name == 'Profile') && isCandidateContactDetailsMissing"></span>
                        </ng-template>
                        <app-candidate-profile *ngIf="tab.isActive && tab.name == 'Profile'"
                            [candidateId]="candidateId" [context]="'conference'"
                            (candidateContactDetailsMissingCallback)="isCandidateContactDetailsMissing = $event">
                        </app-candidate-profile>
                        <app-job-profile *ngIf="tab.isActive && tab.name == 'Job Profile'"
                            [jobId]="jobId" [context]="'conference'">
                        </app-job-profile>
                        <app-candidate-job-comparison *ngIf="tab.isActive && tab.name == 'Compare'"
                            [jobId]="jobId"
                            [jobMatchId]="jobMatchId"
                            [candidateId]="candidateId">
                        </app-candidate-job-comparison>
                        <app-schedules-on-profile *ngIf="tab.isActive && displaySchedules && (tab.name == 'Phone Screen' || tab.name == 'Interview') && !tab.disabled"
                            [jobMatchId]="jobMatchId"
                            [jobMatchObject]="jobMatchInfo"
                            [candidateId]="candidateId"
                            [parentScheduleId]="scheduleId"
                            [scheduleId]="scheduleId"
                            (completeFeedbackCallback)="completeFeedbackCallback.emit()"
                            (saveCallback)="saveCallback.emit()"
                            [feedbackType]="tab.feedbackType"
                            [feedbackUserIdsList]="feedbackUserIdsList"
                            [externalCommentRequired]="false"
                            [loginRequired]="true"
                            [jobLocation]="jobLocation"
                            [displayFeedback]="tab.displayFeedback"
                            [allowInterviewSchedule]="true"
                            (moveToInterviewCallback)="moveToInterviewCallback()"
                            [usersToEditFeedback]="usersToEditFeedback"
                            [feedbackReadOnly]="feedbackReadOnly"
                            [externalMeetingCallId]="externalMeetingCallId"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </app-schedules-on-profile>
                        <div class="row" *ngIf="tab.isActive && tab.name == 'Completed Feedback'">
                            <div class="col-xs-12">
                                <object [attr.data]="tab.url + '#view=fitH'" type="application/pdf"
                                    style="width:100%; height:500px;">
                                    <embed [attr.src]="tab.url" type="application/pdf" width="100%" height="500px">
                                </object>
                            </div>
                        </div>
                        <app-feedback-execution *ngIf="tab.isActive && tab.name == 'Feedback'"
                            [jobMatchId]="jobMatchId"
                            [candidateId]="candidateId"
                            [parentScheduleId]="scheduleId"
                            (completeFeedbackCallback)="feedbackCompleteCallback()"
                            (saveCallback)="saveCallback.emit()"
                            [feedbackType]="tab.feedbackType"
                            [feedbackUserIdsList]="feedbackUserIdsList"
                            [externalCommentRequired]="false"
                            [loginRequired]="true"
                            [usersToEditFeedback]="usersToEditFeedback"
                            [feedbackReadOnly]="feedbackReadOnly"
                            [externalMeetingCallId]="externalMeetingCallId"
                            [context]="'conference'"
                            [sourceScreen]="sourceScreen"
                            [formalizeActivityPayload]="formalizeActivityPayload">
                        </app-feedback-execution>
                        <div class="col-md-12" *ngIf="tab.isActive && tab.name == 'Communication'">
                            <app-notes-and-communication
                                [jobMatchId]="jobMatchId"
                                [type]="'communication'"
                                [contactMethod]="'Outgoing Call'"
                                (saveCallback)="saveCallback.emit()"
                                [candidateInformationList]="jobMatchInfo.candidateInformationList">
                            </app-notes-and-communication>
                        </div>
                        <div class="col-md-12" *ngIf="tab.isActive && (tab.name == 'Interview' || tab.isNextStepPreview) && tab.disabled">
                            <div class="alert alert-warning">
                                <p>{{tab.message}}</p>
                            </div>
                        </div>
                        <div class="row" *ngIf="tab.isActive && tab.isNextStepPreview && tab.isMoveForwardTab && !tab.disabled">
                            <div class="col-md-12">
                                <app-move-job-match-step
                                    [jobMatchId]="jobMatchId"
                                    [moveType]="'Forward'"
                                    [notifyUsers]="true"
                                    [meetingScheduleId]="scheduleId"
                                    [externalMeetingId]="externalMeetingCallId"
                                    (saveCallback)="moveToInterviewCallback()"
                                    [label]="tab.actionLabel"
                                    [candidateId]="candidateId"
                                    [sourceScreen]="sourceScreen"
                                    [formalizeActivityPayload]="formalizeActivityPayload">
                                </app-move-job-match-step>
                            </div>
                        </div>
                        <div class="row" *ngIf="tab.isActive && !tab.isNextStepPreview && tab.name !== 'Profile' && tab.name !== 'Additional Details' && tab.name !== 'Job Profile' && tab.name !== 'Compare' && tab.name !== 'Feedback' && tab.name !== 'Phone Screen' && tab.name !== 'Interview' && tab.name !== 'Communication' && tab.name !== 'Completed Feedback'">
                            <div class="col-xs-12">
                                <object [attr.data]="tab.url + '#view=fitH'" type="application/pdf"
                                    style="width:100%; height:500px;">
                                    <embed [attr.src]="tab.url" type="application/pdf" width="100%" height="500px">
                                </object>
                            </div>
                        </div>
                    </tab>
                </tabset>
            </div>
            <div class="col-xs-12 loading-spinner text-center" *ngIf="isLoading" style="height:400px">
                <div class="skeleton-paragraph skeleton-loading" style="width: 60%; margin: 0 auto 10px;"></div><div class="skeleton-paragraph skeleton-loading" style="width: 40%; margin: 0 auto;"></div>
            </div>
        </div>
    </div>
</div>
